import "./Header.css";

function Header({ toggleSidebar }) {

  const admin = JSON.parse(localStorage.getItem("admin"));
  const token = localStorage.getItem("token");

  const handleLogout = () => {
    localStorage.removeItem("admin");
    localStorage.removeItem("token");

    // redirect to login page
    window.location.href = "/admin/login";
  };

  return (
    <div className="header">

      {/* LEFT */}
      <div className="header-left">
        <button className="menu-btn" onClick={toggleSidebar}>
          ☰
        </button>
      </div>

      {/* RIGHT */}
      <div className="header-right">

        <button className="notif-btn">
          🔔
          <span className="badge">3</span>
        </button>

        {/* 👇 ADMIN NAME (dynamic) */}
        <span className="admin-text">
          {admin?.name ? `Welcome ${admin.name}` : "Welcome Admin"}
        </span>

        {/* 🔥 SHOW LOGOUT ONLY IF LOGGED IN */}
        {token && (
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        )}

      </div>

    </div>
  );
}

export default Header;